module.exports = __webpack_public_path__ + "img/ape-constructor-preview-shape.cb9b20c5.svg";